
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.row {
  display: flex;
  width: 100%;
  gap: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
}@media (min-width: 768px) {.row {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }.row {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.stat-type {
  display: flex;
  color: var(--blue-responsible-main);
  width:50%;
  -moz-column-break-inside:avoid !important;
       break-inside:avoid !important;
}

.stat-data {
  font-weight: var(--fw-bold);
  color: var(--gray-professional-main);
  width:50%;
  -moz-column-break-inside:avoid !important;
       break-inside:avoid !important;
}

.row.variant--default{
  border-top:2px solid #ebebeb !important;
}

.row.variant--clean{
  border-bottom:2px solid;
  border-color: var(--blue-responsible-lighten-4);
}

.variant--clean .stat-type {
  align-items: center;
  justify-content: flex-end;
}

.row.variant--clean .stat-type ::slotted(p) {
  width: 100%;
  text-align: right;
}
`;